import { useState } from "react";
import { Modal, Button } from "flowbite-react";
import MaintenanceHistoryTable from "../tables/MaintenanceHistoryTable";
import {
  confirmMaintenanceCharge,
  contestMaintenanceCharge,
} from "@/common/services/maintenance.api";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import ContestModal from "./ContestModal";
import { IMaintenance } from "@/types/maintenance.type";

type Props = {
  onClosed: () => void;
  licensePlate?: string;
  maintenanceId?: string;
  chargeStatus?: IMaintenance["chargeMaintenance"];
};

function ToCheckModal(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isContestModalOpen, setIsContestModalOpen] = useState(false);
  if (!props.licensePlate || !props.maintenanceId) {
    return null;
  }
  const areActionsDisabled =
    props.chargeStatus?.confirmed || props.chargeStatus?.contested;
  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      const result = await confirmMaintenanceCharge(
        props.maintenanceId as string
      );
      if (result.ok) {
        notifySuccess("Manutenção confirmada com sucesso!");
        props.onClosed();
      } else {
        notifyError(result.message || "Falha ao confirmar manutenção.");
      }
    } catch (err) {
      notifyError("Ocorreu um erro inesperado. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleContestSubmit = async (message: string) => {
    setIsSubmitting(true);
    try {
      if (!props.maintenanceId) {
        notifyError("ID da manutenção não encontrado para contestar.");
        return;
      }
      const result = await contestMaintenanceCharge(
        props.maintenanceId,
        message
      );
      if (result.ok) {
        notifySuccess("Manutenção contestada com sucesso!");
        setIsContestModalOpen(false);
        props.onClosed();
      } else {
        notifyError(result.message || "Falha ao contestar manutenção.");
      }
    } catch (err) {
      notifyError("Ocorreu um erro inesperado. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal size="6xl" show={true} onClose={props.onClosed}>
        <Modal.Header>
          <h2 className="text-black">
            Verificar Histórico da Placa: {props.licensePlate}
          </h2>
        </Modal.Header>
        <Modal.Body>
          <MaintenanceHistoryTable licensePlate={props.licensePlate} />
          <div className="flex justify-end items-center gap-4 mt-6 pt-4 border-t border-gray-200">
            <Button
              color="failure"
              onClick={() => setIsContestModalOpen(true)}
              disabled={isSubmitting || areActionsDisabled}
            >
              Contestar
            </Button>
            <Button
              color="success"
              onClick={handleConfirm}
              isProcessing={isSubmitting}
              disabled={isSubmitting || areActionsDisabled}
            >
              Confirmar
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <ContestModal
        isOpen={isContestModalOpen}
        onClose={() => setIsContestModalOpen(false)}
        onSubmit={handleContestSubmit}
        isSubmitting={isSubmitting}
      />
    </>
  );
}

export default ToCheckModal;
